import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 49 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M24.238 48.001c13.386 0 24.238-10.745 24.238-24S37.624 0 24.238 0 0 10.746 0 24c0 13.256 10.852 24.001 24.238 24.001" }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.485 39.485h5.813v-13.28h4.294l.858-5.364h-5.153v-4.056c0-1.505 1.453-2.356 2.84-2.356h2.51V9.981l-4.492-.197c-4.294-.261-6.673 3.074-6.673 7.065v3.99h-4.888v5.365h4.888v13.28z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }